<fieldset class="ais-RefinementList">
  <div>
    <!-- this div is here to simulate the ng-ais-header container -->
    <button
      *ngIf="options.label === 'CATALOG.FILTERS.COLORS'"
      class="ais-RefinementList-header ais-header"
      [ngClass]="{'ais-RefinementList-header--closed': !showRefinementBody}"
      (click)="toggleShowBody()"
      [attr.aria-expanded]="showRefinementBody"
    >
      <legend i18n="@@CATALOG.FILTERS.COLORS">Colors</legend>
    </button>
  </div>
  <div class="ais-RefinementList-body ais-body" [ngStyle]="{display: showRefinementBody ? 'block' : 'none'}">
    <ul class="ais-RefinementList-list" [ngClass]="{filters__checkboxList__scroll: items.length > 10}">
      <li class="filters_checkbox--color" *ngFor="let item of items; let index = index">
        <a *ngIf="item.url; else label" href="{{ item.url }}" class="filters_checkbox_label">
          <!-- SSR Case -->
          <ng-container *ngTemplateOutlet="innerLabel"></ng-container>
          <span class="filters_checkbox_label__text">{{ item.label }}</span>
        </a>

        <ng-template #label>
          <!-- Browser Case -->
          <input
            id="{{ options.facet }}__{{ item.id || index }}"
            class="filters_checkbox_input visuallyhidden"
            type="checkbox"
            (change)="refine($event, item)"
            [attr.checked]="item.isRefined ? 'checked' : null"
          />
          <label for="{{ options.facet }}__{{ item.id || index }}" class="filters_checkbox_label">
            <ng-container *ngTemplateOutlet="innerLabel"></ng-container>
            <span class="filters_checkbox_label__text"
              >{{ item.label }} <span class="filters_color_label_count">({{ item.count }})</span>
            </span>
          </label>
        </ng-template>

        <ng-template #innerLabel>
          <span
            class="filters_checkbox_label__color"
            [class.hasBorder]="item.settings.type === 'bordered'"
            [class.isUnset]="item.settings.type === 'unset' || !item.settings.type"
            [style.background-color]="item.settings.hexadecimal || null"
            [style.border-color]="item.settings.border || null"
            [style.background-image]="item.settings.image ? 'url(' + item.settings.image + ')' : null"
          >
          </span>
        </ng-template>
      </li>
    </ul>
  </div>
</fieldset>
